const activities = {
    "data": {
        "activities": [
            {
                "activity": "posted",
                "communityURL": "https://developercommunityapi.westus.cloudapp.azure.com/content/problem/1073753/vsftest---test2-dcom2-1.html",
                "date": 1591824447878,
                "rootAnswerHubId": 1073753,
                "rootBodyHtml": "[regression] [worked-in:last week]\nrandom issue\n\n",
                "rootTitle": "vsftest - Test2 DCOM2 1",
                "rootType": "problem",
                "title": "vsftest - Test2 DCOM2 1"
            },
            {
                "activity": "posted",
                "communityURL": "https://developercommunityapi.westus.cloudapp.azure.com/content/problem/1059873/vsftest-test1.html",
                "date": 1591071899523,
                "rootAnswerHubId": 1059873,
                "rootBodyHtml": "fsdfsdfg\n\n",
                "rootTitle": "vsftest test1",
                "rootType": "problem",
                "title": "vsftest test1"
            },
            {
                "activity": "commented",
                "communityURL": "https://developercommunityapi.westus.cloudapp.azure.com/content/problem/1024061/vsftest---test1-dcom2-1.html",
                "date": 1590086031609,
                "rootAnswerHubId": 1024061,
                "rootBodyHtml": "[regression] [worked-in:before COVID19]\nI can&#39;t go out to beach on a <strong>sunny</strong> day like today\n\n",
                "rootTitle": "vsftest - Test1 DCOM2 1",
                "rootType": "problem",
                "title": "Please share more details\n"
            },
            {
                "activity": "posted",
                "communityURL": "https://developercommunityapi.westus.cloudapp.azure.com/content/problem/1039687/vsftest-2456.html",
                "date": 1589944674471,
                "rootAnswerHubId": 1039687,
                "rootBodyHtml": "test sgfdsgsdg\n\n",
                "rootTitle": "vsftest 2456",
                "rootType": "problem",
                "title": "vsftest 2456"
            }
        ],
        "totalCount": 149
    }
};

export default activities;